export class Velocity2D {
    angle: number = 0
    speed: number = 0

    get vx(): number {
        return Math.cos(this.angle * Math.PI / 180) * this.speed;
    }

    get vy(): number {
        return Math.sin(this.angle * Math.PI / 180) * this.speed;
    }
}
